import React, { useEffect, useState } from 'react';
import { Input, Select } from '../../../components/ui/Input';
import Btn from '../../../components/ui/Btn';
import Badge from '../../../components/ui/Badge';
import Secao from '../../../components/ui/Secao';
import { condicoesPagamentoApi } from '../../../api/condicoesPagamento';
import CriarCondicaoPagamentoModal from '../CriarCondicaoPagamentoModal';

const TIPOS_PAGAMENTO = [
  { value: 'boleto', label: 'Boleto' },
  { value: 'pix', label: 'PIX' },
  { value: 'conta', label: 'Conta Bancária / Transferência' }
];

const FORMA_LABEL = {
  boleto: 'Boleto', pix: 'Pix', cartao: 'Cartão', dinheiro: 'Dinheiro',
  transferencia: 'Transferência', cheque: 'Cheque'
};

const TIPOS_PIX = [
  { value: '', label: '(selecione)' },
  { value: 'cpf', label: 'CPF' },
  { value: 'cnpj', label: 'CNPJ' },
  { value: 'email', label: 'Email' },
  { value: 'telefone', label: 'Telefone' },
  { value: 'aleatoria', label: 'Chave Aleatória' }
];

export default function PagamentoFornecedorTab({ form, onChange }) {
  const [condicoes, setCondicoes] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);

  const carregarCondicoes = () => condicoesPagamentoApi.listar().then(setCondicoes).catch(() => {});
  useEffect(() => { carregarCondicoes(); }, []);

  const opcoesCondicoes = [{ value: '', label: '(nenhuma)' }, ...condicoes.map(c => ({ value: c.id, label: c.nome }))];
  const condicaoSelecionada = condicoes.find(c => c.id === Number(form.condicao_pagamento_id));

  const onCriada = (novoId) => {
    setModalAberto(false);
    carregarCondicoes();
    onChange('condicao_pagamento_id', novoId);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <Secao titulo="Condição de Pagamento (que o fornecedor concede)">
        <div style={{ display: 'flex', gap: 10, alignItems: 'end', maxWidth: 500 }}>
          <Select label="Condição de Pagamento" style={{ flex: 1 }} options={opcoesCondicoes}
            value={form.condicao_pagamento_id || ''} onChange={e => onChange('condicao_pagamento_id', e.target.value || null)} />
          <Btn variante="secondary" type="button" onClick={() => setModalAberto(true)}>+ Nova Condição</Btn>
          {condicaoSelecionada && <Badge tom="info">{FORMA_LABEL[condicaoSelecionada.forma_pagamento] || condicaoSelecionada.forma_pagamento}</Badge>}
        </div>
      </Secao>

      <Secao titulo="Dados Bancários (pra pagamento)">
        <Select label="Como pagar este fornecedor" options={TIPOS_PAGAMENTO} value={form.tipo_pagamento || 'boleto'} onChange={e => onChange('tipo_pagamento', e.target.value)} style={{ maxWidth: 300, marginBottom: 8 }} />
        {form.tipo_pagamento === 'conta' && (
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 6 }}>
            <Input label="Banco" value={form.banco || ''} onChange={e => onChange('banco', e.target.value)} />
            <Input label="Agência" value={form.agencia || ''} onChange={e => onChange('agencia', e.target.value)} />
            <Input label="Conta" value={form.conta || ''} onChange={e => onChange('conta', e.target.value)} />
            <Input label="Dígito" value={form.digito || ''} onChange={e => onChange('digito', e.target.value)} />
          </div>
        )}
        {form.tipo_pagamento === 'pix' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 6 }}>
            <Select label="Tipo de Chave" options={TIPOS_PIX} value={form.tipo_pix || ''} onChange={e => onChange('tipo_pix', e.target.value)} />
            <Input label="Chave PIX" value={form.chave_pix || ''} onChange={e => onChange('chave_pix', e.target.value)} />
          </div>
        )}
        {(!form.tipo_pagamento || form.tipo_pagamento === 'boleto') && (
          <p style={{ fontSize: 13, color: '#64748B', margin: 0 }}>Pagamento por boleto — não precisa de dados bancários, só o código de barras de cada compra.</p>
        )}
      </Secao>

      {modalAberto && (
        <CriarCondicaoPagamentoModal
          onFechar={() => setModalAberto(false)}
          onCriada={onCriada}
        />
      )}
    </div>
  );
}
